import { render } from "./CreateStockWithdrawalView.vue?vue&type=template&id=6a6e07d8&scoped=true"
import script from "./CreateStockWithdrawalView.vue?vue&type=script&lang=js"
export * from "./CreateStockWithdrawalView.vue?vue&type=script&lang=js"

import "./CreateStockWithdrawalView.vue?vue&type=style&index=0&id=6a6e07d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6e07d8"]])

export default __exports__